export class Search {
    constructor(
      public find: string,
    ) { }
  }